export const notificationConfig = {
  createSessionSuccess: {
    title: 'Success!',
    icon: 'https://i.ibb.co/YTcSTsT/success-wp-1.png',
    description: ['Payment Successfull'],
    acknowledgementButtonText: 'Close',
  },
};
